import { Box, Button } from '@mui/material';
import { FC, ReactNode } from 'react';
import { ButtonColor } from '../../Button';
import RootModalLayout from '../RootModalLayout';

interface CampaignModalProps {
  title: string;
  content: ReactNode;
  primaryButtonText: string;
  secondaryButtonText?: string;
  showCloseIcon?: boolean;
  onClose: () => void;
  primaryButtonHandler?: () => void;
  secondaryButtonHandler?: () => void;
}

export const CampaignModal: FC<CampaignModalProps> = ({
  title,
  content,
  primaryButtonText,
  secondaryButtonText,
  showCloseIcon = true,
  primaryButtonHandler,
  secondaryButtonHandler,
  onClose,
}) => {
  return (
    <RootModalLayout size='large' onClose={onClose} title={title} showCloseIcon={showCloseIcon}>
      <section>
        <Box>{content}</Box>

        <Box mt={2} display='flex' justifyContent='end' gap={3}>
          {secondaryButtonText && (
            <Button variant='outlined' color={ButtonColor.SECONDARY} onClick={secondaryButtonHandler}>
              {secondaryButtonText}
            </Button>
          )}

          <Button variant='contained' color={ButtonColor.SECONDARY} onClick={primaryButtonHandler ?? onClose}>
            {primaryButtonText}
          </Button>
        </Box>
      </section>
    </RootModalLayout>
  );
};
